import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';

const formatMoney = (value, signed = false) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const numberValue = Number(value);
  const sign = signed && numberValue > 0 ? '+' : '';
  return `${sign}${numberValue.toFixed(2)}€`;
};

const rows = [
  {
    key: 'walletBalance',
    label: 'Net movement',
    signed: true,
  },
  {
    key: 'totalCommissions',
    label: 'Total commissions',
  },
  {
    key: 'totalTips',
    label: 'Total tips',
  },
  {
    key: 'kitPayments',
    label: 'Kit payments',
  },
  {
    key: 'bankTransfers',
    label: 'Bank transfers (IBAN + MBWAY)',
  },
  {
    key: 'penaltiesAndCompensations',
    label: 'Penalties / compensations',
    signed: true,
  },
];

const WasherLedgerKpis = ({ kpis, loading }) => (
  <Card>
    <Box
      sx={{
        p: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        flexWrap: 'wrap',
      }}
    >
      <Box>
        <Typography color="textPrimary" variant="h5">
          Ledger KPIs
        </Typography>
        <Typography color="textSecondary" variant="body2">
          Month and year columns show period movement; all time column shows lifetime movement.
        </Typography>
      </Box>
      <Box sx={{ textAlign: 'right' }}>
        <Typography color="textSecondary" variant="overline">
          Wallet balance
        </Typography>
        <Typography
          color="textPrimary"
          variant="h3"
          sx={{ lineHeight: 1 }}
        >
          {formatMoney(kpis?.allTime?.currentWalletBalance)}
        </Typography>
        <Typography color="textSecondary" variant="caption">
          Remaining to pay the washer
        </Typography>
      </Box>
    </Box>
    <PerfectScrollbar>
      <Box sx={{ minWidth: 800, position: 'relative' }}>
        {loading && (
          <CircularProgress
            style={{
              position: 'absolute',
              top: '20px',
              left: '45%',
            }}
          />
        )}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>KPI</TableCell>
              <TableCell>Current Month</TableCell>
              <TableCell>Current Year</TableCell>
              <TableCell>All Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!loading && rows.map((row) => (
              <TableRow hover key={row.key}>
                <TableCell>{row.label}</TableCell>
                <TableCell>{formatMoney(kpis?.month?.[row.key], row.signed)}</TableCell>
                <TableCell>{formatMoney(kpis?.year?.[row.key], row.signed)}</TableCell>
                <TableCell>{formatMoney(kpis?.allTime?.[row.key], row.signed)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </PerfectScrollbar>
  </Card>
);

WasherLedgerKpis.propTypes = {
  kpis: PropTypes.object,
  loading: PropTypes.bool,
};

export default WasherLedgerKpis;
